import { useEffect } from 'react';

import { useBrandTheme } from './BrandThemeContext';

export const ApplyBrandTheme = () => {
	const { logo, primaryColor, secondaryColor, title } = useBrandTheme();

	useEffect(() => {
		const favicon = document.querySelector('link[rel="icon"]');
		if (favicon) {
			favicon.href = `/favicons/${logo}.ico`;
		}

		const heading = document.getElementById('app-name');
		if (heading) {
			heading.textContent = title;
		}

		const root = document.documentElement;
		root.style.setProperty('--brand-color-primary', primaryColor);
		root.style.setProperty('--brand-color-secondary', secondaryColor);
	}, [logo, primaryColor, secondaryColor, title]);

	return null;
};
